import { Grid } from '@mui/material';
import { WsTypography } from 'wisestep-base';

import CardWrapper from '../../../../features/automatedEmailCampaignSettings/childRoutes/CardWrapper';

const SocialSearchCard = ({
  label,
  helperText = 'Search with boolean code',
  image,
}: {
  label: string;
  helperText?: string;
  image: string;
}) => (
  <CardWrapper>
    <Grid display="flex" flexDirection="column" rowGap={1}>
      <Grid>
        <WsTypography bold>{label}</WsTypography>
        <WsTypography>{helperText}</WsTypography>
      </Grid>
      <Grid alignItems="center" justifyContent="center">
        <img src={image} alt={label} height={50} />
      </Grid>
    </Grid>
  </CardWrapper>
);

export default SocialSearchCard;
